import api from '@/api';
import utilities from '@/helpers/utilities';
import i18n from '@/i18n';

const state = {
    systems: [],
    system: {},
};

const mutations = {
    setSystems(state, systems) {
        state.systems = systems;
    },
    setSystem(state, system) {
        state.system = system;
    },
};

const actions = {

    // CRUD
    async fetchSystem({ commit }, id) {
        const response = await api.systems.fetch(id);
        commit('setSystem', response.data);
    },
    async loadSystems({ commit }) {
        const response = await api.systems.list();
        commit('setSystems', response.data);
    },
    async removeSystem({ dispatch }, form) {
        await api.systems.remove(form.id);
        await dispatch('loadSystems');

        dispatch('showSuccess', i18n.t('message.success.systemRemoved'));
    },
    async saveSystem({ dispatch }, form) {
        const response = await api.systems.save(form);
        await api.systems.approvers.save(response.data.id, form);

        await dispatch('fetchSystem', response.data.id);
    },
    async saveOrUpdateSystem({ dispatch }, form) {
        if (utilities.isEmptyOrZero(form.id)) {
            await dispatch('saveSystem', form);
        } else {
            await dispatch('updateSystem', form);
        }

        await dispatch('loadSystems');
        dispatch('showSuccess', i18n.t('message.success.saved'));
    },
    async updateSystem({ dispatch }, form) {
        await api.systems.update(form.id, form);
        await api.systems.approvers.save(form.id, form);

        await dispatch('fetchSystem', form.id);
        await dispatch('loadDemands');
    },
};

const getters = {
    system(state) {
        return state.system || {};
    },
    systems(state) {
        const systems = state.systems || [];
        return systems.sort((a, b) => utilities.stringCompare(a.acronym, b.acronym));
    },
    systemsValueText(_, getters) {
        return getters.systems.map(({ id, acronym, name }) => ({ value: id, text: `${acronym} - ${name}` }));
    },
    activeSystemsValueText(_, getters) {
        return getters.systems.filter(a => a.isActive)
            .map(({ id, acronym, name, contractItem }) => ({ value: id, text: `${acronym} - ${name}`, contractItemId: contractItem.id }));
    },
    systemsDictionary(_, getters) {
        return getters.systems.reduce((map, obj) => {
            map[obj.id] = obj;
            return map;
        }, {});
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/systems.js